import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import withErrorGuard from "../../HOC/withErrorGuard";
import { getVariantId } from "../../state/selectors/general.selectors";
import {
  getPosition,
  getAcmgTranscript,
} from "../../state/selectors/Pulsar.selectors";
import ExomeDepthBrowser from "../ExomeDepthCnvBrowser";
import DellyCnvBrowser from "../DellyCnvBrowser";

function CnvBrowser({ position }) {
  const { start, end, visStart, visEnd } = position;

  const {
    cnv_originating_analysis_id: originAnalId,
    originating_analysis: geneListOriginAnalysisId,
    analysis_reference_genome: genome,
    is_gene_list_on_cnv_analysis: isGeneListCNV,
    analysis_id: analysisId,
    root_analysis: rootAnalysis,
    was_delly_pipeline_used: isDelly,
    sample_id: sampleId,
  } = window.resultsConfig || {};

  return isDelly ? (
    <DellyCnvBrowser
      visStart={visStart}
      visEnd={visEnd}
      start={start}
      end={end}
      genome={genome}
      analysisId={String(isGeneListCNV ? geneListOriginAnalysisId : analysisId)}
      sampleId={String(sampleId)}
      originAnalId={String(originAnalId)}
      rootAnalysis={String(rootAnalysis)}
    />
  ) : (
    <ExomeDepthBrowser
      visStart={visStart}
      visEnd={visEnd}
      start={start}
      end={end}
      genome={genome}
      analysisId={String(isGeneListCNV ? geneListOriginAnalysisId : analysisId)}
      sampleId={String(sampleId)}
      originAnalId={String(originAnalId)}
      rootAnalysis={String(rootAnalysis)}
    />
  );
}

CnvBrowser.propTypes = {
  position: PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number,
    visStart: PropTypes.number,
    visEnd: PropTypes.number,
  }).isRequired,
};

const mapStateToProps = (state) => {
  return {
    position: getPosition(state),
    variantId: getVariantId(state),
    acmgTranscript: getAcmgTranscript(state),
  };
};

export default connect(mapStateToProps)(
  withErrorGuard(CnvBrowser, "CnvBrowser", "Cnv Browser")
);
